import { createGlobalStyle } from "styled-components";
import Router from "./Router";
import "./styles/font.css";

const GlobalStyle = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "GmarketSansMedium";
  }

  a{
    text-decoration: none;
  }

  .App-layout{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const App = () => {
  return (
    <div className="App">
      <GlobalStyle />
      <Router />
    </div>
  );
}

export default App;
